import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/traffictoday.webp';
import screenshot_target from '../../../images/letterfunnel/stevenbodde.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Steven Bodde"
      firstname="Steven"
      companyname="Traffic Today"
      competition="Adwise en Elevate Digital"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/stevenbodde.js